import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .config(ChatConfig);

/* @ngInject */
function ChatConfig($stateProvider) {

  // $stateProvider
  //
  //   // Chat
  //   .state('chat', {
  //     parent: 'bringoz.site',
  //     url: '/chat',
  //     template: '<chat-view></chat-view>',
  //     controller: function (triBreadcrumbsService) {
  //
  //       // Bread Crumbs
  //       triBreadcrumbsService.reset();
  //       triBreadcrumbsService.addCrumb({name: "Chat"});
  //     }
  //   })
}
